import { useMemo, useState } from 'react';
import Navbar from './Navbar';
import CommandsTab from './tabs/CommandsTab';
import JobsTab from './tabs/JobsTab';
import LogsTab from './tabs/LogsTab';
import CRMTab from './tabs/CRMTab';
import ModelsTab from './tabs/ModelsTab';
import SettingsTab from './tabs/SettingsTab';

const TABS = [
  { id: 'commands', label: 'Commands', icon: '⌘' },
  { id: 'projects', label: 'Projects', icon: '◐' },
  { id: 'jobs', label: 'Jobs', icon: '◎' },
  { id: 'models', label: 'Models', icon: '◑' },
  { id: 'logs', label: 'Logs', icon: '◨' },
  { id: 'settings', label: 'Settings', icon: '◌' },
];

export default function Dashboard(props) {
  const [activeTab, setActiveTab] = useState('commands');
  const [url, setUrl] = useState('https://example.com');

  const selectedProject = useMemo(
    () => props.projects.find((project) => project.id === props.selectedProjectId) || null,
    [props.projects, props.selectedProjectId]
  );

  const tabComponents = {
    commands: (
      <CommandsTab
        url={url}
        config={props.config}
        jobs={props.jobs}
        onSaveProject={props.onSaveProject}
        onLogRun={props.onLogRun}
        onExecuteRun={props.onExecuteRun}
        onExecuteBatch={props.onExecuteBatch}
        onRefreshProjects={props.onRefreshProjects}
        onRefreshJobs={props.onRefreshJobs}
      />
    ),
    jobs: <JobsTab jobs={props.jobs} onRefreshJobs={props.onRefreshJobs} />,
    projects: (
      <CRMTab
        projects={props.projects}
        selectedProject={selectedProject}
        onSelectProject={props.onSelectProject}
        onRefreshProjects={props.onRefreshProjects}
        onRefreshJobs={props.onRefreshJobs}
      />
    ),
    models: <ModelsTab url={url} defaultModel={props.config.default_model} />,
    logs: <LogsTab />,
    settings: <SettingsTab config={props.config} authState={props.authState} onSaveConfig={props.onSaveConfig} />,
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-deep)', display: 'flex', flexDirection: 'column' }}>
      <Navbar url={url} setUrl={setUrl} onLogout={props.onLogout} panelName={props.config.panel_name} />

      <div style={{ background: 'var(--bg-surface)', borderBottom: '1px solid var(--border)', padding: '0 24px', display: 'flex', gap: '2px', overflowX: 'auto', flexShrink: 0 }}>
        {TABS.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            style={{
              padding: '14px 18px',
              background: 'none',
              border: 'none',
              borderBottom: activeTab === tab.id ? '2px solid var(--accent)' : '2px solid transparent',
              color: activeTab === tab.id ? 'var(--text-1)' : 'var(--text-3)',
              fontSize: '13px',
              fontFamily: 'var(--font-display)',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '7px',
            }}
          >
            <span style={{ fontSize: '11px', opacity: 0.7 }}>{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>

      <div style={{ flex: 1, padding: '28px 24px', maxWidth: '1200px', margin: '0 auto', width: '100%' }}>
        {tabComponents[activeTab]}
      </div>
    </div>
  );
}
